import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TypeFormation } from 'src/app/shared/models/typeFormation';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TypeFormationModalAjoutComponent } from '../modal/typeFormation-modal-ajout/typeFormation-modal-ajout.component';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { TypeFormationModalDetailComponent } from '../modal/typeFormation-modal-detail/typeFormation-modal-detail.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-typeFormation',
	templateUrl: './list-typeFormation.component.html',
	styleUrls: ['./list-typeFormation.component.scss']
})
export class ListTypeFormationComponent implements OnInit {
	typeFormation: TypeFormation[] = [];
	currentPage = 1;
	itemsPerPage = 10;

	typeFormationCsvFile: File = null;
	searchedSkill = '';
	searchedName = '';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	sortType = 'firstName';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	editTypeFormationModalRef: BsModalRef;
	addTypeFormationModalRef: BsModalRef;
	screenWidth: number;
	isMobile: boolean = false;

	isListingLoading: boolean = true;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getTypeFormation();
		this.isAddable = true;
	}

	getTypeFormation(): void {
		this.isListingLoading = true;
		this.facade.typeFormationService.getAllTypeFormation().subscribe({
			next: (val) => {
				this.typeFormation = val.filter((e) => e.name !== 'Sans');
				this.itemsPerPage = this.typeFormation.length >= 8 ? 10 : 8;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
				this.typeFormation = [];
			}
		});
	}

	selectTypeFormation(typeFormation: TypeFormation): void {
		const link = ['/typeFormation', typeFormation.id];
		this.router.navigate(link);
	}

	importTypeFormation(event: any): void {
		this.typeFormationCsvFile = event.target.files[0];

		this.facade.typeFormationService
			.importTypeFormation(this.typeFormationCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.alerts.push({
						type: 'success',
						msg: `${importStats.entitiesAdded} typeFormation ont été ajoutés,
                  ${importStats.entitiesBeforeImport} étaient déjà présents.`
					});

					this.getTypeFormation();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		this.addTypeFormationModalRef = this.modalService.show(
			TypeFormationModalAjoutComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addTypeFormationModalRef.onHide.subscribe((reason: string | any) => {
			this.getTypeFormation();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(typeFormation: TypeFormation) {
		const initialState = {
			typeFormation: typeFormation
		};
		this.editTypeFormationModalRef = this.modalService.show(
			TypeFormationModalDetailComponent,
			{
				class: '',
				initialState
			}
		);

		this.editTypeFormationModalRef.onHide.subscribe((reason: string | any) => {
			this.getTypeFormation();
		});
	}
}
